// Replaces src/renderer/src/util/EpicGamesLauncher.ts in the web build.
//
// On non-win32 platforms that module exports `undefined`, which ends up in
// GameModeManager's known-game-stores list. Most consumers filter falsy
// stores, but manualGameStoreSelection (the manage-by-folder flow) does
// not and crashes reading `.id` of undefined. A benign empty store keeps
// every consumer happy.
const epicStub = {
    id: "epic",
    name: "Epic Games Launcher",
    priority: 100,
    allGames: () => Promise.resolve([]),
    reloadGames: () => Promise.resolve(),
    isGameStoreInstalled: () => Promise.resolve(false),
    getGameStorePath: () => Promise.resolve(undefined),
};

module.exports = epicStub;
module.exports.default = epicStub;
